import React, { Component } from 'react';
import { Clearfix, FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Validation } from '../../helper';
//import Button from '@material-ui/core/Button';

const view = Object.freeze({ "passwordResetForm": 0, "okResponseView": 1, "notValidView": 2 });

export default class ResetPassword extends Component {
    displayName = ResetPassword.name;
    constructor(props) {
        super(props);

        const params = new URLSearchParams(this.props.location.search);

        this.state = {
            submitEnabled: true,
            view: view.passwordResetForm,
            email: params.get('u'),
            resetToken: params.get('t')
        };
    }

    onSubmit = async (e) => {
        e.preventDefault();
        const data = {
            'email': this.state.email,
            'resetToken': this.state.resetToken,
            'newPassword': this.newPassword.value,
            'confirmPassword': this.confirmPassword.value
        };

        this.newPassword.disabled = true;
        this.confirmPassword.disabled = true;
        this.setState({ errors: [], submitEnabled: false });

        var response = await fetch("/api/login/resetpassword", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (response.ok) {
            this.setState({ ...this.state, view: view.okResponseView });
        }
        else {
            this.handleErrors(response);
        }
    }

    handleErrors = async (response) => {
        var errorResult = await response.json();
        this.setState({ ...this.state, errorResult: errorResult, submitEnabled: true });

        this.newPassword.disabled = false;
        this.confirmPassword.disabled = false;

        // If errors have not been reported at the field level, then this is a generally invalid request
        if (errorResult !== undefined && (errorResult.errors === undefined || errorResult.errors.length === 0))
            this.setState({ ...this.state, view: view.notValidView });
    }

    renderPasswordResetForm() {
        return (
            <div>
                <div className="text-center" style={{ paddingBottom: '35px', maxWidth: '30em', margin: 'auto' }}>
                    <div style={{ marginTop: '1em' }}>
                        <strong>Reset your password: {this.state.email}</strong>
                    </div>
                </div>

                <form onSubmit={this.onSubmit.bind(this)} style={{ maxWidth: '25em', margin: 'auto' }}>
                    <FormGroup controlId="newPassword" validationState={Validation.getFieldValidationState("newPassword", this.state.errorResult)}>
                        <ControlLabel>New Password</ControlLabel>
                        <FormControl componentClass="input" type="password" name="newPassword" placeholder="Password" autoComplete="new-password" inputRef={(ref) => this.newPassword = ref} />
                        <HelpBlock>{Validation.getFieldValidationText("newPassword", this.state.errorResult)}</HelpBlock>
                    </FormGroup>
                    <FormGroup controlId="confirmPassword" validationState={Validation.getFieldValidationState("confirmPassword", this.state.errorResult)} >
                        <ControlLabel>Confirm Password</ControlLabel>
                        <FormControl componentClass="input" type="password" name="confirmPassword" placeholder="Password" autoComplete="new-password" inputRef={(ref) => this.confirmPassword = ref} />
                        <HelpBlock>{Validation.getFieldValidationText("confirmPassword", this.state.errorResult)}</HelpBlock>
                    </FormGroup>
                    <Clearfix />
                    <div className="text-center">
                        <button style={{ margin: '0' }} type="submit" className="btn-block ogcButton" ref={(ref) => this.submitButton = ref} disabled={!this.state.submitEnabled}>SUBMIT</button>
                    </div>
                </form>
            </div>
        );
    }

    renderOkResponseView() {
        return (
            <div className="text-center" style={{ paddingBottom: '35px', maxWidth: '30em', margin: 'auto', marginTop: '1em' }}>
                <div style={{ marginTop: '1em' }}>
                    <strong>Reset Your Password</strong>
                </div>
                <div style={{ marginTop: '1em' }}>
                    You have successfully reset your password. Go to the login page to sign in.
                </div>
                <div style={{ marginTop: '2em' }}>
                    <Link to="/login">Go to Login</Link>
                </div>
            </div>
        );
    }

    renderNotValidView() {
        return (
            <div className="text-center" style={{ paddingBottom: '35px', maxWidth: '30em', margin: 'auto', marginTop: '1em' }}>
                <div style={{ marginTop: '1em' }}>
                    <strong>Unable to Reset Password</strong>
                </div>
                <div style={{ marginTop: '1em' }}>
                    The request URL is not valid or has expired. Return to Login page and click "Forgot Password" to make a new request.
                </div>
                <div style={{ marginTop: '2em' }}>
                    <Link to="/login">Go to Login</Link>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div style={{ paddingBottom: '25px' }}>
                {this.state.view === view.passwordResetForm && this.renderPasswordResetForm()}
                {this.state.view === view.okResponseView && this.renderOkResponseView()}
                {this.state.view === view.notValidView && this.renderNotValidView()}
                <style>
                    {styleOverride}
                </style>
            </div>
        );
    }
}

const styleOverride = `body { background-color:white; }`;



// WEBPACK FOOTER //
// ./src/components/Login/ResetPassword.js